'use client';

import clsx from 'clsx';
import React, { FC, InputHTMLAttributes } from 'react';

import styles from './styles.module.css';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  error?: string | null;
}

const Input: FC<Props> = ({ error, ...inputProps }) => {
  return (
    <div className={styles.container}>
      {error && <div className={styles.error}>{error}</div>}
      <input {...inputProps} className={clsx(styles.input, inputProps.className)} />
    </div>
  );
};

export default Input;
